import React from "react";
import { useTranslation } from "react-i18next";
import { ResourceTypes } from "@planzone/dto";
import { RoleSelection } from "./roleSelection";
import { Props } from "./types";
import styles from "./styles.scss";

function Form({ formData, isDisabled, editForm }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.form}>
      {formData.resource.type !== ResourceTypes.MATERIAL && (
        <React.Fragment>
          <h2 className={styles.label}>{t("editProjectResource.inputRole")}</h2>
          <RoleSelection
            placeholder={t("editProjectResource.inputRole")}
            selectedRole={formData.role}
            isDisabled={isDisabled}
            select={(role) => role && editForm({ ...formData, role })}
          />
        </React.Fragment>
      )}
    </div>
  );
}

export { Form };
